import { FilterField, FilterFieldType, FilterFieldConfig } from '../filter';

export interface SearchSelectFilterFieldConfig extends FilterFieldConfig {
  options?: any[];
  optionDisplayProperty?: string;
  placeholder?: string;
  showSearch?: boolean;
  title?: string;
  dropdownWidth?: string;
  width?: number;
  closeOnClick?: boolean;
}

const MIN_WIDTH = 200;

export class SearchSelectFilterField extends FilterField<any> {
  readonly type: FilterFieldType = 'search-select';
  options: any[];
  optionDisplayProperty: string | null;
  placeholder: string | null;
  showSearch: boolean;
  title: string | null;
  dropdownWidth: string | null;
  closeOnClick: boolean;
  width: number;

  constructor(config: SearchSelectFilterFieldConfig) {
    super(config);
    this.options = config.options || [];
    this.optionDisplayProperty = config.optionDisplayProperty || null;
    this.placeholder = config.placeholder || null;
    this.showSearch = config.showSearch !== undefined ? config.showSearch : true;
    this.title = config.title || null;
    this.dropdownWidth = config.dropdownWidth || null;
    this.width = config.width && config.width > MIN_WIDTH ? config.width : MIN_WIDTH;
    // default to true to support original functionality
    const { closeOnClick = true } = config;
    this.closeOnClick = !!closeOnClick;
  }

  appliedFieldText(): string {
    return `${this.name}: ${this.value[this.optionDisplayProperty!]}`;
  }

  serializeValue(): string {
    return `${this.value[this.optionDisplayProperty!]}`;
  }

  deserializeValue(urlParam: string): any {
    return this.options.find((option) => option[this.optionDisplayProperty!] === urlParam) || null;
  }

  searchSelectFieldWidth(): number {
    return this.width;
  }
}
